import React from 'react';

import styles from '../title.module.scss';
import { ReactComponent as LegalTerm } from '../../../../../public/img/icons/entities/definition.svg';

export const LegalTermIcon = <LegalTerm className={styles.icon} />;
